import { t } from '@lingui/core/macro';
import { DOCUMENT_METADATA_GROUPS, DOCUMENT_METADATA_GROUP_KEYS, DOCUMENT_METADATA_NESTED_GROUPS, DOCUMENT_METADATA_NESTED_GROUP_KEYS, } from './groups';
export const getDocumentMetadataGroups = (items) => {
    const groupKeys = Object.keys(DOCUMENT_METADATA_GROUPS);
    const nestedGroupKeys = Object.keys(DOCUMENT_METADATA_NESTED_GROUPS);
    const addedItems = []; // Keep track of what items we have added to a group
    const groupLabels = {
        [DOCUMENT_METADATA_GROUP_KEYS.GENERAL_INFORMATION]: t({
            message: 'General information',
            comment: 'Global search: Metadata filter group - General information',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.LIFECYCLE_AND_STATUS]: t({
            message: 'Lifecycle and status',
            comment: 'Global search: Metadata filter group - Lifecycle and status',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.DATES]: t({
            message: 'Dates',
            comment: 'Global search: Metadata filter group - Dates',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.COMMERCIAL]: t({
            message: 'Commercial',
            comment: 'Global search: Metadata filter group - Commercial',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.RENEWAL_AND_TERMINATION]: t({
            message: 'Renewal and termination',
            comment: 'Global search: Metadata filter group - Renewal and termination',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.LIABILITY_AND_RISK]: t({
            message: 'Liability and risk',
            comment: 'Global search: Metadata filter group - Liability and risk',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.HR]: t({
            message: 'HR',
            comment: 'Global search: Metadata filter group - HR',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.REGULATORY]: t({
            message: 'Regulatory',
            comment: 'Global search: Metadata filter group - Regulatory',
        }),
        [DOCUMENT_METADATA_GROUP_KEYS.ACCESS]: t({
            message: 'Access',
            comment: 'Global search: Metadata filter group - Access',
        }),
    };
    const nestedGroupLabels = {
        [DOCUMENT_METADATA_NESTED_GROUP_KEYS.CLAUSES_AND_TERMS]: t({
            message: 'Clauses and terms',
            comment: 'Global search: Metadata filter group - Clauses and terms',
        }),
    };
    let groups = groupKeys.reduce((acc, groupKey) => {
        const groupProperties = DOCUMENT_METADATA_GROUPS[groupKey];
        const groupItems = items.filter((item) => groupProperties.includes(item.id));
        if (groupItems.length === 0) {
            return acc;
        }
        addedItems.push(...groupItems);
        const group = {
            type: 'group',
            key: groupKey,
            label: groupLabels[groupKey],
            properties: groupItems,
        };
        return [...acc, group];
    }, []);
    const nestedGroups = nestedGroupKeys.reduce((acc, nestedGroupKey) => {
        const nestedGroupProperties = DOCUMENT_METADATA_NESTED_GROUPS[nestedGroupKey];
        const nestedGroup = {
            type: 'nested',
            key: nestedGroupKey,
            label: nestedGroupLabels[nestedGroupKey],
            groups: groups.filter((group) => nestedGroupProperties.includes(group.key)),
        };
        // Remove the nested group from the groups array
        groups = groups.filter((group) => !nestedGroupProperties.includes(group.key));
        return [...acc, nestedGroup];
    }, []);
    return [...groups, ...nestedGroups];
};
